
import React from 'react';

const CartProcessIcon = ({ width = 56, height = 56, color = "#FE531F" }) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 57 57" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_140_25325)">
        <mask
          id="mask0_140_25325"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="57"
          height="57"
        >
          <path d="M56.4925 0.212158H0V56.7047H56.4925V0.212158Z" fill="white" />
        </mask>
        <g mask="url(#mask0_140_25325)">
          <path
            d="M54.1388 10.8043H50.608V7.27353C50.608 5.97891 49.5487 4.91968 48.2541 4.91968C46.9595 4.91968 45.9003 5.97891 45.9003 7.27353V10.8043H42.3695C41.0749 10.8043 40.0156 11.8635 40.0156 13.1582C40.0156 14.4528 41.0749 15.512 42.3695 15.512H45.9003V19.0428C45.9003 20.3374 46.9595 21.3967 48.2541 21.3967C49.5487 21.3967 50.608 20.3374 50.608 19.0428V15.512H54.1388C55.4334 15.512 56.4926 14.4528 56.4926 13.1582C56.4926 11.8635 55.4334 10.8043 54.1388 10.8043Z"
            fill={color}
          />
        </g>
        <mask
          id="mask1_140_25325"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="57"
          height="57"
        >
          <path d="M56.4925 0.212158H0V56.7047H56.4925V0.212158Z" fill="white" />
        </mask>
        <g mask="url(#mask1_140_25325)">
          <path
            d="M49.431 40.2273H11.7693C10.4747 40.2273 9.41542 39.1681 9.41542 37.8734C9.41542 36.5788 10.4747 35.5196 11.7693 35.5196H44.7232C45.6452 35.5196 46.4886 34.9703 46.8613 34.1269L48.9798 29.4192C49.5094 28.2422 48.9994 26.8692 47.8225 26.3199C46.6652 25.7707 45.2725 26.2611 44.7036 27.4184L43.1736 30.8119H16.1435L13.5935 14.3349H32.954C34.2486 14.3349 35.3078 13.2756 35.3078 11.981C35.3078 10.6864 34.2486 9.62717 32.954 9.62717H12.8677L11.7693 2.21253C11.5927 1.05522 10.5923 0.192138 9.41542 0.211754H2.35385C1.05923 0.211754 0 1.27099 0 2.56561C0 3.86023 1.05923 4.91946 2.35385 4.91946H7.39503L11.3966 30.8119C8.29734 31.0276 5.68848 33.2442 5.00194 36.2846C4.3154 39.325 5.68848 42.4438 8.39542 43.9935C7.51272 45.3273 7.06156 46.8769 7.06156 48.4658C7.06156 53.0166 10.7493 56.7043 15.3001 56.7043C19.8508 56.7043 23.5385 53.0166 23.5385 48.4658C23.5385 47.2496 23.2443 46.0335 22.7147 44.935H33.7778C33.2482 46.0335 32.954 47.2496 32.954 48.4658C32.954 53.0166 36.6417 56.7043 41.1925 56.7043C45.7432 56.7043 49.431 53.0166 49.431 48.4658C49.431 47.2496 49.1367 46.0335 48.6071 44.935H49.431C50.7256 44.935 51.7848 43.8758 51.7848 42.5811C51.7848 41.2865 50.7256 40.2273 49.431 40.2273ZM18.8308 48.4658C18.8308 49.8977 17.9678 51.1727 16.6535 51.722C15.3393 52.2712 13.8093 51.9573 12.8089 50.9569C11.8085 49.9566 11.4947 48.4265 12.0439 47.1123C12.5931 45.7981 13.8681 44.935 15.3001 44.935C17.242 44.935 18.8308 46.5238 18.8308 48.4658ZM44.7232 48.4658C44.7232 49.8977 43.8602 51.1727 42.5459 51.722C41.2317 52.2712 39.7017 51.9573 38.7013 50.9569C37.7009 49.9566 37.3871 48.4265 37.9363 47.1123C38.4855 45.7981 39.7605 44.935 41.1925 44.935C43.1344 44.935 44.7232 46.5238 44.7232 48.4658Z"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_140_25325">
          <rect
            width="56.4925"
            height="56.4925"
            fill="white"
            transform="translate(0 0.212158)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CartProcessIcon;